import * as Sentry from '@sentry/vue';
import getAgritaskEnvFromUrl from '@/vue/utils/getAgritaskEnvFromURL';
const environment = getAgritaskEnvFromUrl();
const SENTRY_PROJECT = 'https://0298db3e038d463f8390bce661f0c077@o1295063.ingest.sentry.io/6520236';
/**
 * Adding Sentry plugin
 * @param {App} app
 * @param {boolean} initRoot Initializes the root instance for Sentry,
 * should be done only once for the entire FE
 */
export const addSentryPlugin = (app, initRoot) => {
    initRoot ? initRootSentry(app) : attachSentryToAdditionalApps(app);
};
const initRootSentry = (app) => {
    Sentry.init({
        app,
        dsn: SENTRY_PROJECT,
        integrations: [
            new Sentry.BrowserTracing({
                tracePropagationTargets: ['agritask.com', 'pescout.com', 'agritask.xyz', /^\//],
            }),
            new Sentry.Replay({
                maskAllText: false,
            }),
        ],
        environment,
        // Set tracesSampleRate to 1.0 to capture 100% of transactions for performance monitoring.
        tracesSampleRate: 0.2,
        // This sets the sample rate to be 10%. You may want this to be 100% while
        // in development and sample at a lower rate in production
        replaysSessionSampleRate: 0.1,
        // If the entire session is not sampled, use the below sample rate to sample
        // sessions when an error occurs.
        replaysOnErrorSampleRate: 1.0,
    });
};
const options = {
    trackComponents: false,
    timeout: 2000,
    hooks: ['activate', 'mount', 'update'],
    logErrors: true,
};
export const attachSentryToAdditionalApps = (app) => {
    app.mixin(Sentry.createTracingMixins(options));
    Sentry.attachErrorHandler(app, { ...options, attachProps: true });
};
